<header>
    <div class="info-header container-fluid">
        <div class="row flex-nowrap align-items-center justify-content-between">
            <div class="col-auto flex-shrink-1">
                <button
                    type="button"
                    class="btn-back mat-elevation-z0 px-2 pr-md-3"
                    mat-flat-button
                    color="gray"
                    (click)="onBack()"
                    *ngIf="showBack"
                >
                    <mat-icon>chevron_left</mat-icon>
                    <span class="font-weight-light d-none d-md-inline">{{ 'general.back' | translate }}</span>
                </button>
                <div class="mat-subheading-2 ml-3 mb-0">
                    <strong class="mr-3" *ngIf="!contract || !contract.isAdvisoryModelSuitabilityOrGDC()">{{
                        'header.client-registration' | translate
                    }}</strong>
                    <strong class="mr-3" *ngIf="contract && contract.isAdvisoryModelSuitability()">{{
                        'header.new-account-advice' | translate
                    }}</strong>
                    <strong class="mr-3" *ngIf="contract && contract.isAdvisoryModelGDC()">{{
                        'header.new-account-gdc' | translate
                    }}</strong>
                    <span class="text-blue d-block d-md-inline" *ngIf="agent">
                        <span class="d-none d-sm-inline">{{ 'header.agent' | translate }}: </span>
                        <strong>{{ agent.name }} {{ agent.surname }}</strong>
                    </span>
                </div>
            </div>
            <div class="col-auto justify-content-end">
                <button type="button" class="btn-wrapper mat-elevation-z0" mat-flat-button color="gray" (click)="onDictionary()">
                    <i class="icon-book mb-md-2"></i>
                    <span class="font-weight-light d-none d-md-inline" [innerHTML]="'header.dictionary' | translate"></span>
                </button>
                <button type="button" class="btn-wrapper mat-elevation-z0" mat-flat-button color="blue" (click)="onPhone()">
                    <i class="icon-phone mb-md-2"></i>
                    <span class="font-weight-light d-none d-md-inline" [innerHTML]="'header.phone-help' | translate"></span>
                </button>
            </div>
        </div>
    </div>
</header>
